// export const getPackageIncludeEmoticon = '${baseurl}'
const baseurl = process.env.REACT_APP_BFF_URL

export const getEveryStickerCategoryPathname = `${baseurl}/emoji-category`
export const getPackageWithSticker = (packageId: string) =>
  `${baseurl}/packages/${packageId}`
export const getPackageListPathname = (userOid: string) =>
  `${baseurl}/creators/${userOid}/packages`
export const putPackagePathname = (packageId: string) =>
  `${baseurl}/packages/${packageId}`
export const postPackagePathname = `${baseurl}/packages`

export const postStickerPathname = process.env
  .REACT_APP_EMOTICON_UPLOAD as string
export const putStickerCategory = (stickerOid: string) =>
  `${baseurl}/stickers/${stickerOid}/emoji-category`
export const submitPackagePathname = (packageId: string) =>
  `${baseurl}/packages/${packageId}/request-inspection`
export const replaceStickerPathname = process.env
  .REACT_APP_REPLACE_STICKER_FILE as string
export const deleteStickerPathname = (stickerOid: string) =>
  `${baseurl}/stickers/${stickerOid}`

export const putPackageStatusEditing = (packageId: string) =>
  `${baseurl}/packages/${packageId}/status`

  export const putPackageResetPathname = (packageId: string) =>
  `${baseurl}/packages/${packageId}/textlang/reset`
